import { DeviceInternalsPage } from "fleet/view/device/internals";
import { connect } from "react-redux";
import { createPromiseApiAction } from "redux-store/api-sagas";
import { GET_INTERNAL_STATE_DEVICE } from "redux-store/devices";

function mapDispatchToProps(dispatch) {
  return {
    fetchInternalState: (deviceId) => {
      return createPromiseApiAction(dispatch, GET_INTERNAL_STATE_DEVICE, [
        deviceId,
      ]);
    },
  };
}

const ConnectedDeviceInternalsPage = connect(
  null,
  mapDispatchToProps,
)(DeviceInternalsPage);

export { ConnectedDeviceInternalsPage };
